import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';

// Config is loaded at runtime from /config.json (injected by server.js from App Service env vars).
// Fallback values are used for local dev (set VITE_ vars in .env.local).
export async function loadRuntimeConfig() {
  const defaults = {
    apiBaseUrl:      import.meta.env.VITE_API_BASE_URL      || 'http://localhost:7071/api',
    msalClientId:    import.meta.env.VITE_MSAL_CLIENT_ID    || '',
    msalAuthority:   import.meta.env.VITE_MSAL_AUTHORITY    || 'https://login.microsoftonline.com/common',
    msalRedirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI || window.location.origin,
    portalEnv:       import.meta.env.VITE_PORTAL_ENV        || 'local',
  };
  try {
    const res = await fetch('/config.json');
    if (res.ok) {
      const runtime = await res.json();
      // Merge: runtime values override defaults only when present and non-empty
      return {
        apiBaseUrl:      runtime.apiBaseUrl      || defaults.apiBaseUrl,
        msalClientId:    runtime.msalClientId    || defaults.msalClientId,
        msalAuthority:   runtime.msalAuthority   || defaults.msalAuthority,
        msalRedirectUri: runtime.msalRedirectUri || defaults.msalRedirectUri,
        portalEnv:       runtime.portalEnv       || defaults.portalEnv,
      };
    }
  } catch {
    // Running locally via Vite — fall through to defaults
  }
  return defaults;
}

export function buildMsalConfig(cfg: { msalClientId: string; msalAuthority: string; msalRedirectUri: string }): Configuration {
  return {
    auth: {
      clientId:    cfg.msalClientId,
      authority:   cfg.msalAuthority,
      redirectUri: cfg.msalRedirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Error,
      },
    },
  };
}

export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

export const apiScopes = (clientId: string) => [`api://${clientId}/Portal.Access`];
